import { createFileRoute } from '@tanstack/react-router'
import { CompanyWelcomeDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import { CompanyWelcomeDialog } from '@/routes/_app/-components/companies/welcome-dialog'

export const Route = createFileRoute('/@modal/welcome/company')({
  staticData: { slotScope: '/_app' },
  pendingComponent: CompanyWelcomeDialogPending,
  component: CompanyWelcomeSlot,
})

function CompanyWelcomeSlot() {
  const slot = useModalSlot(Route)
  return <CompanyWelcomeDialog open={slot.open} />
}
